// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2PyHE","col":"styles_col__4DRaE"};